<template>
    <div>
        <app-sub-title text="Herramientas" />
        <button class="btn btn-primary" @click="startCreate">
            <i class="fa fa-plus"></i> Crear Herramienta
        </button>
        <app-item-filters @filter="onFilter" :item-types="itemTypes" />
        <app-item-list
            v-if="!!items"
            :data="items"
            :on-change-page="onChangePage"
            :on-edit="onEdit"
            :on-delete="startDeleteType"
            :unassign="startUnassign"
            @sort="onSort"
        />

        <!-- PopUps -->
        <b-modal
            size="lg"
            id="item-form-window"
            title="Formulario de Item"
            ok-title="Guardar"
            cancel-title="Cancelar"
            @ok.prevent="$refs['item-form'].save()"
        >
            <app-item-form
                :my-item="itemSelect"
                :item-types="itemTypes"
                ref="item-form"
                @created="onItemCreated"
            />
        </b-modal>

        <app-pop-up title="Confirmación" id="item-remove">
            <div slot="body">
                <h2>¿Esta seguro que desea eliminar esta herramienta?</h2>
            </div>
            <div class="buttons" slot="buttons">
                <button class="btn btn-confirm" @click="deleteItem(itemSelect)">
                    <i class="fa fa-trash-o" aria-hidden="true"></i> Confirmar
                    Eliminación
                </button>
            </div>
        </app-pop-up>

        <app-pop-up title="desasignación de herramientas" id="unassign-tool">
            <div slot="body">
                <h3>Esta seguro que desea desasignar esta herramienta?</h3>
            </div>
            <div slot="buttons">
                <button class="btn btn-confirm" @click="unassignItem">
                    Aceptar
                </button>
            </div>
        </app-pop-up>
        <!-- Fin PopUps -->
    </div>
</template>
<script>
import itemsRepository from '../../../repositories/items.repository'
import ItemForm from './ItemForm/ItemForm.vue'
import ItemList from './ItemsList/ItemsList.vue'
import ItemFilters from './ItemsFilters/ItemsFilters.vue'
import { mapGetters } from 'vuex'

export default {
    components: {
        appItemForm: ItemForm,
        appItemList: ItemList,
        appItemFilters: ItemFilters,
    },

    data() {
        return {
            items: null,
            page: 1,
            itemSelect: '',
            sort: {
                sortBy: 'name',
                sortDir: 'asc',
            },
            filters: null,
            itemTypes: [],
        }
    },
    computed: {},
    methods: {
        async loadItemTypes() {
            const { data } = await repo.get('item-types', { with: 'fields' })
            this.itemTypes = data
        },
        async loadItems() {
            const filters = {
                ...this.filters,
                sortBy: this.sort.sortBy,
                sortDir: this.sort.sortDir,
                page: this.page,
            }
            this.items = await this.get('items', filters)
        },
        onItemCreated(item) {
            this.loadItems()
            this.closeModal('item-form-window')
        },
        onFilter(filters) {
            this.filters = filters
            this.page = 1
            this.loadItems()
        },
        onChangePage(page) {
            this.page = page
            this.loadItems()
        },
        onEdit(item) {
            this.itemSelect = Object.assign({}, item)
            this.$bus.$emit('item-form.open')
        },
        deleteItem(item) {
            const pr = { ...itemsRepository }

            pr.deleteItem(item.id)
                .then(data => {
                    if (!!data.status) {
                        this.loadItems()
                        this.$bus.$emit('item-remove.close')
                        toastr.success('La herramienta ha sido eliminada')
                    } else {
                        toastr.error(data.msg)
                    }
                })
                .catch(error => {
                    toastr.error('Ocurrió un error al eliminar la herramienta')
                })
        },
        startDeleteType(item) {
            this.itemSelect = item
            this.$bus.$emit('item-remove.open')
        },
        startCreate() {
            this.itemSelect = ''
            // this.$bus.$emit('item-form.open')
            this.openModal('item-form-window')
        },
        save() {},
        onSave() {
            this.$bus.$emit('item-form.close')
            this.loadItems()
        },
        cleanForm() {
            this.$bus.$emit('item-form.clean')
        },
        startUnassign(item) {
            this.itemSelect = item
            this.$bus.$emit('unassign-tool.open')
        },
        unassignItem() {
            const ir = Object.assign({}, itemsRepository)
            ir.unassignStructure(this.itemSelect.id)
                .then(data => {
                    if (data.status) {
                        this.loadItems()
                        toastr.success(data.msg)
                        this.$bus.$emit('unassign-tool.close')
                    } else {
                        toastr.error(data.msg)
                    }
                })
                .catch(error => {
                    toastr.error('Error al desasignar la herramienta')
                })
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy
            this.sort.sortDir = ctx.sortDir
            this.loadItems()
        },
    },

    created() {
        this.loadItemTypes()
        this.loadItems()
    },
}
</script>
